module.exports = __webpack_public_path__ + "static/media/26.a2c2d6b8.jpg";